import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  };

  return (
    <div className="language-switcher">
      <span 
        className={currentLang === 'en' ? 'active' : ''}
        onClick={() => changeLanguage('en')}
      >
        EN
      </span>
      <span className="divider">/</span>
      <span 
        className={currentLang === 'ar' ? 'active' : ''}
        onClick={() => changeLanguage('ar')}
      >
        عربي
      </span>
    </div>
  );
};

export default LanguageSwitcher;
